<ng-container *ngIf="variantId$ | async as variantId">
    <lib-rnimu-quiz
      [variantId]="variantId"
      [accessibleMode]="false"
      [connectionRefused$]="connectionRestored$"
      [connectionLost$]="connectionLost$"
      [backUrl]="backUrl"
    ></lib-rnimu-quiz>
</ng-container>
